import { fetch, buildUrl } from 'domain/Api';
import is from 'is_js';
import { ApiCall, PrivilegeChecker } from 'omni-common-ui';
import {
  actions as studentReportSummariesActions,
} from 'data/ProgressReports/StudentReportSummaries';
import Privileges from 'domain/Privileges';

export const FETCH_PROGRESS_TEST_REQUEST = 'FETCH_PROGRESS_TEST_REQUEST';
export const FETCH_PROGRESS_TEST_SUCCESS = 'FETCH_PROGRESS_TEST_SUCCESS';
export const FETCH_PROGRESS_TEST_FAILURE = 'FETCH_PROGRESS_TEST_FAILURE';
export const SUBMIT_PROGRESS_TEST_RESULTS_REQUEST = 'SUBMIT_PROGRESS_TEST_RESULTS_REQUEST';
export const SUBMIT_PROGRESS_TEST_RESULTS_SUCCESS = 'SUBMIT_PROGRESS_TEST_RESULTS_SUCCESS';
export const SUBMIT_PROGRESS_TEST_RESULTS_FAILURE = 'SUBMIT_PROGRESS_TEST_RESULTS_FAILURE';

export const RETAKE_PROGRESS_TEST_REQUEST = 'RETAKE_PROGRESS_TEST_REQUEST';
export const RETAKE_PROGRESS_TEST_SUCCESS = 'RETAKE_PROGRESS_TEST_SUCCESS';
export const RETAKE_PROGRESS_TEST_FAILURE = 'RETAKE_PROGRESS_TEST_FAILURE';


export function fetchProgressTest(groupId, { name, id }) {
  const progressTestId = id;
  return (dispatch) => {
    const url = buildUrl(`/progress-tests/${progressTestId}/content`);
    const method = 'GET';

    return dispatch(fetchProgressTestRequest()).payload
      .then((response) => dispatch(fetchProgressTestSuccess(response, name)))
      .catch((error) => dispatch(fetchProgressTestFailure(error)));

    function fetchProgressTestRequest() {
      const content = fetch(url);
      const results = fetch(buildUrl(`/progress-tests/${progressTestId}/results`));
      const payload = Promise.all([content, results])
        .then(([contentResp, resultsResp]) => ({
          ...contentResp,
          ...resultsResp,
          skills: contentResp.skills || resultsResp.skills,
        }));
      return ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_REQUEST,
        url,
        method,
        payload,
        groupId,
        progressTestId,
      });
    }

    function fetchProgressTestSuccess(content, progressTestName) {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_SUCCESS,
        payload: content,
        url,
        method,
        groupId,
        progressTestId,
        name: progressTestName,
      });
    }

    function fetchProgressTestFailure(error) {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_FAILURE,
        error,
        url,
        method,
        groupId,
        progressTestId,
      });
    }
  };
}

export function getProgressReportId(state, groupId, progressTestId) {
  if (is.undefined(progressTestId)) return undefined; // prevent test from crash
  const progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId).data;
  return progressTestsPlan.get(progressTestId).progressReportId;
}

export function enabledExportPT(progressTest) {
  return progressTest && progressTest.startTime && progressTest.startTime > '2023-04-01';
}

export function submitProgressTestResults(groupId, progressTestId, model,
  progressReportId, needToFetchStudentReport) {
  return (dispatch, getState) => {
    const url = buildUrl(`/progress-tests/${progressTestId}/results`);
    const method = 'PUT';
    return dispatch(submitProgressTestResultsRequest()).payload
      .then((response) => dispatch(submitProgressTestResultsSuccess(response)))
      .catch((error) => dispatch(submitProgressTestResultsFailure(error)))
      .then(() => dispatch(fetchProgressTest(groupId, { id: progressTestId })))
      .then(() => {
        if (needToFetchStudentReport &&
          PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressReport.View)) {
          dispatch(studentReportSummariesActions.fetchStudentReportSummaries(progressReportId));
        }
      });

    function submitProgressTestResultsRequest() {
      const request = fetch(url,
        {
          method,
          body: JSON.stringify(model),
        }
      );
      return ApiCall.createAction({
        type: SUBMIT_PROGRESS_TEST_RESULTS_REQUEST,
        payload: request,
        url,
        method,
        groupId,
        progressTestId,
        model,
      });
    }

    function submitProgressTestResultsSuccess() {
      return ApiCall.createAction({
        type: SUBMIT_PROGRESS_TEST_RESULTS_SUCCESS,
        url,
        method,
      });
    }

    function submitProgressTestResultsFailure(error) {
      return ApiCall.createAction({
        type: SUBMIT_PROGRESS_TEST_RESULTS_FAILURE,
        url,
        method,
        error,
      });
    }
  };
}

export function retakeProgressTest(groupId, { progressTestId, studentId }, progressReportId) {
  return (dispatch, getState) => {
    const url = buildUrl(`/progress-tests/${progressTestId}/retake/${studentId}`);
    const method = 'GET';

    return dispatch(retakeProgressTestRequest()).payload
      .then((response) => dispatch(retakeProgressTestSuccess(response, name)))
      .catch((error) => dispatch(retakeProgressTestFailure(error)))
      .then(() => dispatch(fetchProgressTest(groupId, { id: progressTestId })))
      .then(() => {
        if (PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressReport.View)) {
          dispatch(studentReportSummariesActions.fetchStudentReportSummaries(progressReportId));
        }
      });

    function retakeProgressTestRequest() {
      const result = fetch(url);
      const payload = Promise.all([result])
        .then((responses) => Object.assign.apply({}, responses));
      return ApiCall.createAction({
        type: RETAKE_PROGRESS_TEST_REQUEST,
        url,
        method,
        payload,
        groupId,
        progressTestId,
        studentId,
      });
    }

    function retakeProgressTestSuccess(content, progressTestName) {
      return ApiCall.createAction({
        type: RETAKE_PROGRESS_TEST_SUCCESS,
        payload: content,
        url,
        method,
        groupId,
        progressTestId,
        name: progressTestName,
        studentId,
      });
    }

    function retakeProgressTestFailure(error) {
      return ApiCall.createAction({
        type: RETAKE_PROGRESS_TEST_FAILURE,
        error,
        url,
        method,
        groupId,
        progressTestId,
        studentId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/ProgressTests/actions.js